module.exports = __webpack_public_path__ + "media/images/sport--Para_SkiNordisch-2616ec997381827073e108e4fb6c403b.png";